// extracted by mini-css-extract-plugin
export var burntOrange = "Talent-module--burntOrange--a03d4";
export var chalkBoardBlack = "Talent-module--chalkBoardBlack--ba267";
export var cigaretteWhite = "Talent-module--cigaretteWhite--15073";
export var description = "Talent-module--description--457a5";
export var descriptionCopy = "Talent-module--descriptionCopy--5ae18";
export var descriptionInner = "Talent-module--descriptionInner--3a67b";
export var download = "Talent-module--download--1dca6";
export var fadedLavender = "Talent-module--fadedLavender--7a3e1";
export var link = "Talent-module--link--1d2f3";
export var links = "Talent-module--links--9cee1";
export var oliveGreen = "Talent-module--oliveGreen--992a2";
export var overlay = "Talent-module--overlay--3fd6a";
export var overlayInner = "Talent-module--overlayInner--91cbb";
export var paperWhite = "Talent-module--paperWhite--ebaf9";
export var pistachioGreen = "Talent-module--pistachioGreen--3db11";
export var showreelsWrap = "Talent-module--showreelsWrap--262c6";
export var title = "Talent-module--title--01756";
export var velvetRed = "Talent-module--velvetRed--20e62";